import script from "./SocialProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialProfilePage.vue?vue&type=script&setup=true&lang=js"

import "./SocialProfilePage.vue?vue&type=style&index=0&id=d7b3ef5a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7b3ef5a"]])

export default __exports__